import { Routes } from '@angular/router';

// import { LoginComponent } from './login/login.component';
// import { SignupComponent } from './signup/signup.component';
// // import { HeaderComponent } from './header/header.component';
// import { UserComponent } from './user/user.component';
// import { UserResolver } from './user/user.resolver';
// import { AuthGuard } from './core/auth.guard';


import { StuloginComponent } from './stulogin/stulogin.component';
import { UserComponent } from './user/user.component';
import { SignupComponent } from './signup/signup.component';
import { UserResolver } from './user/user.resolver';
import { AuthGuard } from './core/auth.guard';
import { MainpageComponent } from './mainpage/mainpage.component';
import { AdminloginComponent } from './adminlogin/adminlogin.component';
import { HomeComponent } from './home/home.component';
import { AuthadminGuard } from './adminauth/authadmin.guard';
// import { SearcheditemComponent } from './searcheditem/searcheditem.component'
// import { HeartComponent } from './heart/heart.component'

export const rootRouterConfig: Routes = [
  // { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'loginpage',redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: StuloginComponent, canActivate: [AuthGuard] },
  { path: 'signup', component: SignupComponent, canActivate: [AuthGuard] },
  { path: 'user', component: UserComponent,  resolve: { data: UserResolver}},
  { path: '', component:MainpageComponent},
  { path: 'adminlogin', component:AdminloginComponent},
  { path: 'adminhome', component:HomeComponent, canActivate: [AuthadminGuard]},
  // { path:'searcheditem',component:SearcheditemComponent},
  // { path:'heart',component:HeartComponent}
];
